import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import API_BASE_URL from '../../config';
import Button from '../../components/Button';
import '../Login.css';

const AgencyRegister: React.FC = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address');
            return;
        }

        // Phone validation (Indian 10-digit)
        const phoneRegex = /^[6-9]\d{9}$/;
        if (!phoneRegex.test(phone)) {
            setError('Please enter a valid 10-digit phone number');
            return;
        }

        // Password strength validation
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(password)) {
            setError('Password must be at least 8 characters and include uppercase, lowercase, number, and special character (@$!%*?&)');
            return;
        }

        setLoading(true);

        try {
            const cleanPassword = password.trim();
            const response = await fetch(`${API_BASE_URL}/api/agency/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, phone, password: cleanPassword, subscriptionPlan: 'free' })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Registration failed');
            }

            setSuccess(true);
        } catch (err: any) {
            setError(err.message || 'An error occurred during registration.');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="login-container">
                <div className="login-card p-8">
                    <h2 className="text-2xl font-bold mb-4 text-center">Application Submitted!</h2>
                    <p className="text-center mb-6">Your agency account is pending approval by our platform admins. You will be notified once activated.</p>
                    <Button label="Return to Login" onClick={() => history.push('/agency/login')} />
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-card mt-8">
                <div className="login-header">
                    <h1 className="login-title">Event Agency Partner</h1>
                    <p className="login-subtitle">Apply for a B2B agency account to manage multiple weddings</p>
                </div>

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Agency Name</label>
                        <input type="text" value={name} onChange={e => setName(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label>Contact Email</label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label>Contact Phone</label>
                        <input type="text" value={phone} onChange={e => setPhone(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
                    </div>

                    {error && <div className="error-message text-red-500 mb-4">{error}</div>}

                    <Button
                        label={loading ? 'Submitting...' : 'Apply Now'}
                        onClick={() => {}}
                        disabled={loading}
                        className="login-button w-full mt-4"
                    />
                </form>
                
                <div className="login-footer mt-4 text-center">
                    Already have an account? <a href="/agency/login" onClick={(e) => { e.preventDefault(); history.push('/agency/login'); }} className="text-brand cursor-pointer">Login here</a>
                </div>
            </div>
        </div>
    );
};

export default AgencyRegister;
